goog.provide("shadow.js.shim.module$moment$min$locales");
goog.provide("module$shadow_js_shim_module$moment$min$locales");
shadow.js.shim.module$moment$min$locales = shadow.js.nativeProvides["moment/min/locales"] = shadow$bridge("moment/min/locales");
module$shadow_js_shim_module$moment$min$locales.default = shadow.js.shim.module$moment$min$locales;
